<!--
 * @Author: wsx
 * @Date: 2022-01-19 16:52:00
 * @LastEditTime: 2022-03-05 10:47:31
 * @LastEditors: Please set LastEditors
 * @Description:菜单管理
-->
<template>
  <el-container class='MenuManage'>
    <el-card class="tree-card" :body-style="treeCard">
        <el-row>
          <el-col>
            <h-button type="primary" @click="addButton">添加</h-button>
            <h-button @click="editMenu">编辑</h-button>
            <h-button type="danger" @click="delUser">删除</h-button>
          </el-col>
        </el-row>
      <el-input
        v-model="filterText"
        placeholder="请输入关键词"
        class="input-with-select"
      >
        <template #prefix>
          <i class="iconfont icon-31sousuo"></i>
        </template>
      </el-input>
      <div class="tree-box">
        <el-tree
          ref="treeRef"
          :data="dataSource"
          node-key="menuId"
          highlight-current
          :props="{label:'name'}"
          :default-expanded-keys="[rootNodeKey]"
          @current-change="currentChange"
          :expand-on-click-node="true"
          :filter-node-method="filterNode"
        >
        </el-tree>
      </div>
    </el-card>
    <el-card  class="tabs-card">
      <div class="table-box">
        <h-table
          ref="tableRef"
          v-model:columns="columns"
          :method="getMenuListAsync"
          :params="tableParams"
          :paging="false"
          @handleClick="handleClick"
          @select="hzTableSelect"
          >
          <template #menuType="{row}">
            <span>{{menuType[row.type] || ''}}</span>
          </template>
        </h-table>

      </div>
    </el-card>
    <menu-form
      v-model="formVisible"
      v-model:form="userFormData"
      :status="formStatus"
      @submit="userSubmit"
    >
    </menu-form>
    <import-dialog  v-model="importVisible" @submit="userSubmit"></import-dialog>
  </el-container>
</template>
<script >
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  watch,
  ref
} from 'vue';
import { ElMessageBox, ElMessage } from 'element-plus';
import { getMenuList, delMenu } from '@/api/system/menu';
import menuForm from './components/menuForm.vue';
import importDialog from './components/importDialog.vue';
import util from '@util/js';
import _ from 'lodash';
export default defineComponent({
  name: 'MenuManage',
  components: { menuForm, importDialog },
  props: {},
  setup(props) {
    const state = reactive({
      filterText: '',
      rootNodeKey: '',
      treeCard: {
        height: '100%',
        display: "flex",
        flexDirection: "column"
      },
      currentNode: {},
      importVisible: false,
      formVisible: false,
      formStatus: 1, // 1 添加  2 编辑
      userFormData: {},
      dataSource: [],
      tableData: [],
      tableSelection: [],
      tableParams: {
        parentId: '',
        type: 1
      },
      menuType: { 0: "目录", 1: "菜单", 2: "按钮" },
      columns: [{
        label: '姓名',
        prop: 'name'
      }, {
        label: '路由',
        prop: 'url'
      }, {
        label: '类型',
        prop: 'type',
        slot: 'menuType'
      }, {
        label: '图标',
        prop: 'icon'
      }, {
        label: '状态',
        prop: 'statusDict'
      }, {
        type: "operate",
        label: '操作',
        width: '310px',
        operates: [
          { name: '编辑', emitKey: 'edit' },
          { name: '删除', emitKey: 'del', type: 'danger' }
        ]
      }
      ]
    });
    const refData = toRefs(state);
    const treeRef = ref(null);
    const tableRef = ref(null);
    const formRef = ref(null);
    // 组织树的筛选
    watch(() => state.filterText, (v) => {
      treeRef.value && treeRef.value.filter(v);
    });
    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      state.currentNode = item;
      state.tableParams.parentId = item.menuId;
      state.userFormData.parentId = item.menuId;
      nextTick(() => {
        tableRef.value && tableRef.value.refresh();
      });
    };
    // 对组织树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };

    // 获取结构树
    const queryOrganTreAsync = async () => {
      const result = await getMenuList();
      const list = result.menuList.filter(item => item.type !== 2);
      const options = { pid: 'parentId', id: 'menuId', rootPid: 0 };
      const treeData = util.arrayToTree(list, options);
      state.dataSource = treeData;
      if (treeData[0]) {
        if (!state.currentNode.menuId) {
          currentChange(treeData[0]);
        }
        nextTick(() => {
          state.rootNodeKey = state.currentNode.menuId;
          treeRef.value.setCurrentKey(state.currentNode.menuId);
        });
      }
    };
    queryOrganTreAsync();
    const getMenuListAsync = async (params) => {
      const result = await getMenuList(params);
      return {
        code: 0,
        page: {
          list: result.menuList
        }
      };
    };
    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 点击添加按钮
    const addButton = () => {
      state.formStatus = 1;
      state.formVisible = true;
    };
    // 删除菜单数据
    const deleteUserAsync = async (ids) => {
      const res = await delMenu(ids);
      if (res.code === 0) {
        refreshTable();
        const node = treeRef.value.getNode(ids);
        treeRef.value.remove(node);
        state.currentNode = {};
        ElMessage({
          type: 'success',
          message: '删除成功'
        });
      }
    };

    // 编辑
    const editMenu = () => {
      if (state.currentNode.menuId) {
        state.formStatus = 2; // 把表单设置为编辑状态
        state.userFormData = _.cloneDeep(state.currentNode);
        state.formVisible = true;
      } else {
        ElMessage({
          type: 'warning',
          message: '请选择要修改的菜单'
        });
      }
    };

    // 点击table操作按钮
    const handleClick = (operate, row) => {
      const { emitKey } = operate;
      if (emitKey === 'edit') {
        // 编辑
        state.formStatus = 2; // 把表单设置为编辑状态
        state.userFormData = _.cloneDeep(row);
        state.formVisible = true;
      } else if (emitKey === 'del') {
        ElMessageBox.confirm(
          '您确认要删除该菜单吗？',
          '删除',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
          .then(() => {
            deleteUserAsync(row.menuId);
          }, () => {});
      }
    };
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    const hzTableSelect = (selection) => {
      state.tableSelection = selection;
    };
    // 表单提交
    const userSubmit = () => {
      tableRef.value && tableRef.value.refresh();
      queryOrganTreAsync();
    };
    // 批量删除用户
    const delUser = () => {
      if (state.currentNode.menuId) {
        ElMessageBox.confirm(
          '您确认要删除选择的菜单吗？',
          '删除',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
          .then(() => {
            deleteUserAsync(state.currentNode.menuId);
          }, () => {});
      } else {
        ElMessage({
          type: 'warning',
          message: '请选择要删除的菜单'
        });
      }
    };

    return {
      ...refData,
      refreshTable,
      treeRef,
      formRef,
      tableRef,
      filterNode,
      currentChange,
      hzTableSelect,
      handleClick,
      getMenuListAsync,
      userSubmit,
      delUser,
      editMenu,
      addButton
    };
  }
});
</script>
<style  lang='scss' scoped >
.MenuManage {
  .tree-card{
    height: 100%;
    width: 300px;
    .input-with-select{
      margin-bottom: 10px;
      margin-top: 10px;
    }
    .tree-box{
      flex: 1;
      overflow: auto;
      position: relative;
      .tree-header{
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name{
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status{
          width: 50px;
        }
      }
    }
  }
  .tabs-card{
    flex: 1;
    margin-left: 10px;
    .tabs-tabel-box{
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
      .table-box{
        flex: 1;
        overflow: hidden;
        .table-role{
          background-color: var(--el-color-info-lighter);
          box-sizing: border-box;
          border-color: transparent;
          border-radius: 5px;
          margin: 2px 0 2px 6px;
          text-align: center;
        }
      }
  }
}
</style>
